var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 40C130.209 40 132 41.7909 132 44L132 136C132 138.209 130.209 140 128 140L12 140C9.79086 140 8 138.209 8 136L8 44C8 41.7909 9.79086 40 12 40L128 40Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 40C130.209 40 132 41.7909 132 44L132 47L8 47L8 44C8 41.7909 9.79086 40 12 40L128 40Z",
    fill: "#B5BECC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138 30C140.209 30 142 31.7909 142 34L142 126C142 128.209 140.209 130 138 130L22 130C19.7909 130 18 128.209 18 126L18 34C18 31.7909 19.7909 30 22 30L138 30Z",
    fill: "#1E95F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138 30C140.209 30 142 31.7909 142 34L142 37L18 37L18 34C18 31.7909 19.7909 30 22 30L138 30Z",
    fill: "#156DD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9765 95.2992L95.2764 89.6571C95.5136 89.2313 95.5136 88.7203 95.2764 88.3158L94.2411 86.5273L88.7197 95.9805H90.8118C91.2863 95.9805 91.7392 95.725 91.9765 95.2992Z",
    fill: "#FAFBFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0243 95.2974L97.8223 93.9561C98.0596 93.5303 98.0596 93.0193 97.8223 92.6148L96.7871 90.8477L93.7676 96H95.8597C96.3126 95.9787 96.7655 95.7233 97.0243 95.2974Z",
    fill: "#FAFBFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.215 95.9805L64.6937 86.5273L63.6584 88.3158C63.4212 88.7416 63.4212 89.2526 63.6584 89.6571L66.9367 95.2992C67.174 95.725 67.6269 95.9805 68.1229 95.9805H70.215Z",
    fill: "#FAFBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2132 90.7617L61.1779 92.5289C60.9407 92.9547 60.9407 93.4657 61.1779 93.8702L61.9975 95.2967C62.2348 95.7225 62.6877 95.978 63.1837 95.978H65.2758L62.2132 90.7617Z",
    fill: "#FAFBFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3118 95.9783H85.7647C86.2607 95.9783 86.7137 95.7228 86.9509 95.297L92.7742 85.3329C93.0115 84.9071 93.0115 84.3961 92.7742 83.9916L91.739 82.2031L84.4922 94.5731L85.3118 95.9783Z",
    fill: "#FAFBFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2404 95.9793L68.0152 83.6094H66.376L66.1604 84.0139C65.9231 84.4397 65.9231 84.9507 66.1604 85.3552L71.9837 95.298C72.2209 95.7239 72.6739 95.9793 73.1699 95.9793H75.2404Z",
    fill: "#FAFBFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4137 92.7403L90.2507 81.0516C90.488 80.6258 90.488 80.1148 90.2507 79.7103L89.2155 77.9219L81.9902 90.2918L83.4137 92.7403Z",
    fill: "#FAFBFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1709 83.6094L77.0079 95.298C77.2452 95.7239 77.6981 95.9793 78.1941 95.9793H80.2862L73.0394 83.6094H70.1709Z",
    fill: "#FAFBFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0874 83.6094H75.1973L82.0343 95.298C82.2715 95.7239 82.7245 95.9793 83.2205 95.9793H85.3126L78.0874 83.6094Z",
    fill: "#FAFBFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7667 68.2578H76.1669C75.6708 68.2578 75.2395 68.5133 74.9807 68.9391L73.9238 70.7063H84.9881L83.9529 68.9178C83.6941 68.5133 83.2411 68.2578 82.7667 68.2578Z",
    fill: "#FAFBFB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2874 64H78.6482C78.1522 64 77.7208 64.2555 77.462 64.6813L76.4268 66.4697H82.5089L81.4736 64.6813C81.2364 64.2555 80.7835 64 80.2874 64Z",
    fill: "#FAFBFB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.693 73.6231L86.4557 73.2399C86.2185 72.8141 85.7656 72.5586 85.2695 72.5586H73.6229C73.1268 72.5586 72.6954 72.8141 72.4366 73.2399L71.4014 75.0283H85.8734L86.693 73.6231Z",
    fill: "#FAFBFB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7949 76.8594H71.1209C70.6248 76.8594 70.1935 77.1149 69.9347 77.5407L68.8994 79.3291H83.3715L84.7949 76.8594Z",
    fill: "#FAFBFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4328 81.8219L66.376 83.6104H80.848L82.2931 81.1406H68.619C68.123 81.1619 67.67 81.4174 67.4328 81.8219Z",
    fill: "#FAFBFB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.693 73.625L79.4678 85.995L80.9128 88.4647L87.7498 76.776C87.9871 76.3502 87.9871 75.8392 87.7498 75.4347L86.693 73.625Z",
    fill: "#FAFBFB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/empty-table.7f634a1f.svg";
export { ForwardRef as ReactComponent };